/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { transformEntityToAttrs } from "data/dto/entity/transformers/transform-entity-to-attrs";
import { EntityAttribute } from "./entity-attribute";
import { EntityContext } from "cms/entity/context";

const Entity = (props) => {
    
    const entity = props?.entity;
    const guid = entity?.guid;
    
    const onEntityChange = props?.onEntityChange;
    const schema = props?.schema;

    const attrs = transformEntityToAttrs(entity, schema);
    
    const updateAttribute = (name,value) => {
        const newEntity = { 
            ...entity,
            [name]: value
        };
        console.log(name, value);
        onEntityChange(newEntity);
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div>
                    <div className="entity-container-wrapper">
                        <div className="entity-container">

                            {attrs?.map((attr,position) => {
                                const name = attr?.key;
                                const value = attr?.value;
                                const type = attr?.type;
                                const entityContext = { schema, entity, attr, updateAttribute };
                                
                                return (
                                    <EntityContext.Provider key={position} value={entityContext}>
                                        <EntityAttribute
                                            reference={guid}
                                            type={type}
                                            key={`${name}${position}`}
                                            name={name}
                                            value={value}
                                            position={position}
                                        />
                                    </EntityContext.Provider>
                                );
                            })}

                            
                            {/*<div style={{ fontWeight: "700"}}>Entity Schema</div>*/}
                            {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                            {/*    {JSON.stringify(schema, null, 2)}*/}
                            {/*</pre>*/}
                            {/*<div style={{ fontWeight: "700"}}>Entity</div>*/}
                            {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                            {/*    {JSON.stringify(entity, null, 2)}*/}
                            {/*</pre>*/}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { Entity };
